import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import IssueStatus from '@opsbase/lib-issue/IssueStatus/IssueStatus';
import Palette from '@opsbase/lib-palette';
import useIssueUpdate from '@opsbase/react-gql-hooks/issue/useIssueUpdate';
import useSelection from '@opsbase/web-data-selection/useSelection';
import useSelectionActions from '@opsbase/web-data-selection/useSelectionActions';
import { Dialog } from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import Horizontal from '@opsbase/web-layout/Horizontal/Horizontal';
import Pane from '@opsbase/web-layout/Pane/Pane';
import Vertical from '@opsbase/web-layout/Vertical/Vertical';
import useNav from '@opsbase/web-nav/useNav/useNav';
import useParams from '@opsbase/web-nav/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import DatePicker from '@opsbase/web-pickers/DatePicker/DatePicker';
import FlagPicker from '@opsbase/web-pickers/FlagPicker/FlagPicker';
import IssueTypePicker from '@opsbase/web-pickers/IssueTypePicker/IssueTypePicker';
import Button from '@opsbase/web-ui/Button/Button';
import { Checkbox } from '@opsbase/web-ui/Checkbox';
import Radio from '@opsbase/web-ui/Radio/Radio';
import { RadioGroup } from '@opsbase/web-ui/RadioGroup/RadioGroup';
import React, { useCallback, useMemo, useState } from 'react';
function IssueMultiEditDialog() {
    const { id } = useParams();
    const dataType = DataType.ISSUE;
    const { selecteds } = useSelection(dataType);
    const { clearSelection } = useSelectionActions(dataType);
    const { raise } = useNotificationActions();
    const updateIssue = useIssueUpdate();
    const [changeIssueType, setChangeIssueType] = useState(false);
    const [changeFlagType, setChangeFlagType] = useState(false);
    const [changeDeadlineDate, setChangeDeadlineDate] = useState(false);
    const [changeStatus, setChangeStatus] = useState(false);
    const [busy, setBusy] = useState(false);
    const ids = useMemo(() => (id === 'selected' ? selecteds.map(o => o.id) : [id]), [id, selecteds]);
    const { goBack } = useNav();
    const [patch, setPatch] = useState({});
    const handleAction = useCallback(async () => {
        setBusy(true);
        return raise(Promise.all(ids.map(theId => updateIssue({ id: theId, patch }))).finally(() => {
            clearSelection();
            setBusy(false);
            goBack();
        }), i18n.t('issue-edit-successful'));
    }, [raise, ids, updateIssue, patch, clearSelection, goBack]);
    const handleClose = useCallback(() => goBack(), [goBack]);
    const handleFieldUpdate = useCallback(field => value => {
        setPatch({ ...patch, [field]: value });
    }, [patch]);
    const isClosed = (patch === null || patch === void 0 ? void 0 : patch.status) === IssueStatus.CLOSED;
    return (React.createElement(Dialog, { size: DialogSize.X800_Y550, title: i18n.t('edit-selected-issues'), padded: false, buttonsLeft: React.createElement(Button, { onClick: handleClose, color: Palette.Grey, disabled: busy, tabIndex: 1, label: i18n.t('cancel') }), buttonsRight: React.createElement(Button, { onClick: handleAction, disabled: busy, tabIndex: 0, label: i18n.t('make-updates') }), scroll: true },
        React.createElement(Pane, { paddingX: true },
            React.createElement(Vertical, { gutter: true },
                React.createElement(Checkbox, { label: i18n.t('change-issue-type'), color: Palette.GoodOldBlue, checked: changeIssueType, onChange: setChangeIssueType }),
                changeIssueType && (React.createElement(Pane, { paddingX: 16 },
                    React.createElement(IssueTypePicker, { white: true, fullWidth: true, value: patch === null || patch === void 0 ? void 0 : patch.type, onChange: handleFieldUpdate('type') }))),
                React.createElement(Checkbox, { label: i18n.t('change-issue-priority'), color: Palette.GoodOldBlue, checked: changeFlagType, onChange: setChangeFlagType }),
                changeFlagType && !isClosed && (React.createElement(Pane, { paddingX: 16 },
                    React.createElement(FlagPicker, { noMargin: true, fullWidth: true, white: true, value: patch.flag, onChange: handleFieldUpdate('flag') }))),
                React.createElement(Checkbox, { label: i18n.t('change-deadline-date'), color: Palette.GoodOldBlue, checked: changeDeadlineDate, onChange: setChangeDeadlineDate }),
                changeDeadlineDate && !isClosed && (React.createElement(Pane, { paddingX: 16 },
                    React.createElement(DatePicker, { noMargin: true, fullWidth: true, white: true, value: patch.deadlineDate || undefined, onChange: handleFieldUpdate('deadlineDate') }))),
                React.createElement(Checkbox, { label: i18n.t('change-issue-status'), color: Palette.GoodOldBlue, checked: changeStatus, onChange: setChangeStatus }),
                changeStatus && (React.createElement(Pane, { paddingX: 16 },
                    React.createElement(RadioGroup, { value: patch.status, onChange: handleFieldUpdate('status') },
                        React.createElement(Horizontal, { justify: "flex-start", gutter: true, centered: true },
                            React.createElement(Radio, { label: i18n.t('mark-all-closed'), value: IssueStatus.CLOSED, checked: patch.status === IssueStatus.CLOSED, color: Palette.positive }),
                            React.createElement(Radio, { label: i18n.t('mark-all-started'), value: IssueStatus.IN_PROGRESS, checked: patch.status === IssueStatus.IN_PROGRESS, color: Palette.positive }),
                            React.createElement(Radio, { label: i18n.t('mark-all-notstarted'), value: IssueStatus.NEW, checked: patch.status === IssueStatus.NEW, color: Palette.error })))))))));
}
export default IssueMultiEditDialog;
